function Embed(src) {

    return src.replace(new RegExp("(\\.?be(\\.com)?\\/)(embed\\/)?(watch\\?v=)?"), 'be.com/embed/') + '?origin=' + window.location.origin;  //movie URL changed from link directing to YT to embedded movie
}

export default Embed;